module.exports = __webpack_public_path__ + "img/roomsText.0b30bbf1.png";